import { useState } from 'react';

interface VideoPlayerProps {
  cover: string;
  title: string;
  duration: string;
}

export default function VideoPlayer({ cover, title, duration }: VideoPlayerProps) {
  const [playing, setPlaying] = useState(false);

  return (
    <div>
      <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-background-100 border border-background-200">
        <img
          src={cover}
          alt={title}
          title={`${title} - 演示播放器`}
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-50/45" />

        <div className="absolute inset-0 flex items-center justify-center">
          <button
            type="button"
            onClick={() => setPlaying((p) => !p)}
            aria-label={playing ? '暂停' : '播放'}
            className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-500 text-background-50 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className={`${playing ? 'ri-pause-fill' : 'ri-play-fill'} text-3xl md:text-4xl`} />
          </button>
        </div>

        {playing && (
          <span className="absolute top-4 left-4 px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium flex items-center gap-1.5 animate-soft-fade">
            <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse" />
            正在演示
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-background-50 to-transparent">
          <div className="h-1 rounded-full bg-background-300/80 overflow-hidden">
            <div className={`h-full rounded-full bg-primary-500 transition-all duration-500 ${playing ? 'w-1/3' : 'w-0'}`} />
          </div>
          <div className="flex items-center justify-between mt-3">
            <div className="flex items-center gap-4 text-foreground-800">
              <button type="button" onClick={() => setPlaying((p) => !p)} className="cursor-pointer">
                <i className={`${playing ? 'ri-pause-line' : 'ri-play-line'} text-lg`} />
              </button>
              <i className="ri-volume-up-line text-lg" />
              <span className="text-xs text-foreground-700">01:20 / {duration}</span>
            </div>
            <div className="flex items-center gap-4 text-foreground-800">
              <i className="ri-settings-3-line text-lg" />
              <i className="ri-fullscreen-line text-lg" />
            </div>
          </div>
        </div>
      </div>
      <p className="text-xs text-foreground-500 mt-3 flex items-start gap-1.5 leading-relaxed">
        <i className="ri-information-line mt-0.5" />
        本播放器为前端模拟演示，播放与进度控制无实际功能，待后端数据接口接入后启用真实视频源。
      </p>
    </div>
  );
}